module.exports = __webpack_public_path__ + "img/sh-logo.f0a03d7c.png";